export default "__VITE_ASSET__CL6YHpps__"